import { translate } from '../services/i18n';

const ClarityEvent = {
  HAIR_LOSS: translate('ENUM.CLARITY_EVENT.HAIR_LOSS'),
  MELATONIN: translate('ENUM.CLARITY_EVENT.MELATONIN'),
  ED: translate('ENUM.CLARITY_EVENT.ED'),
  EJ: translate('ENUM.CLARITY_EVENT.EJ'),
  BE: translate('ENUM.CLARITY_EVENT.BE'),
  WL: translate('ENUM.CLARITY_EVENT.WL'),
  RWL: translate('ENUM.CLARITY_EVENT.RWL'),
  REGISTER_FORM: translate('ENUM.CLARITY_EVENT.REGISTER_FORM'),
};

export default ClarityEvent;
